import cn from 'classnames';
import { Switch } from '@ds';
import { MdViewAgenda as RowsIcon, MdViewWeek as ColumnsIcon } from 'react-icons/md';

type BoardLayoutModeSwitcherProps = {
  checked: boolean;
  onChange: () => void;
};

/* eslint-disable react/no-unstable-nested-components */
export const BoardLayoutModeSwitcher = ({ checked, onChange }: BoardLayoutModeSwitcherProps) => {
  return (
    <Switch
      size="lg"
      color="default"
      isSelected={checked}
      onValueChange={onChange}
      startContent={<RowsIcon />}
      endContent={<ColumnsIcon />}
      thumbIcon={({ isSelected }) => (isSelected ? <ColumnsIcon /> : <RowsIcon />)}
      classNames={{
        base: 'group',
        wrapper: cn('w-20 h-9 m-0 px-0 bg-base-60', 'group-data-[selected=true]:bg-base-60'),
        thumb: cn(
          'h-9 w-9 bg-base-5 text-lg text-base-90',
          'group-data-[selected=true]:ml-11',
          'group-data-[pressed=true]:w-11',
          'group-data-[selected=true]:group-data-[pressed=true]:ml-9',
        ),
        startContent: 'text-xl left-2',
        endContent: 'text-base-5 text-xl right-2',
      }}
    />
  );
};
